import isWebview from "is-ua-webview";
import {customAlphabet} from 'nanoid';

export function getCurrentQueryObject(){
	const map = {};
	const params = new URLSearchParams(window.location.search);
	params.forEach((value, key)=>{
		map[key] = decodeURIComponent(value || '');
	})
	// window.location.search.substring(1).split('&').map((item) => item.split('=')).forEach((x) => {
	// 	map[x[0]] = decodeURIComponent(x[1]);
	// });
	return map;
}

export function twitterShare(url, text){
	return `https://twitter.com/share?text=${text||""}&url=${encodeURIComponent(url)}`;
}
export function facebookShare(url, text){
	return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}&quote=${text||""}`
}

export function pinterestShare(url, text, imageURL){
	return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&description=${text||""}&image_url=${encodeURI(imageURL)}`
}
export function linkedInShare(url, text){
	return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${text||""}&summary=${text}&source=`;
}

const mobileAndTabletcheck = function() {
	var check = false;
	// @ts-ignore
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
};

export function whatsAppShare(url, text) {
	let share = text ? text +encodeURIComponent("\n\n") : '';
	share += encodeURIComponent(url);
	if(mobileAndTabletcheck()){
		return `whatsapp://send?text=${share}`
	}else {
		return `https://web.whatsapp.com/send?phone&text=${share}&source&data`;
	}
}

export function emailShare(url, text){
	return `mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`;
}


export function openShareWindow(href, target, features){
	if(isWebview(window.navigator && window.navigator.userAgent)){
		window.location = href
	}else{
		window.open(href, target, features);
	}
}

export function socialMediaLinkParser(link){
	if(link && link.startsWith('http')) {
		const url = new URL(link);
		if (url) {
			const {hostname, pathname} = url;
			if (hostname.includes('youtube') || hostname.includes('yt')) {
				return {
					type:'youtube',
					href:link,
					title:pathname.replace("/channel/",'').replace('/user/','')
				};
			} else if (hostname.includes('facebook') || hostname.includes('fb')) {
				return {
					type:'facebook',
					href:link,
					title:pathname.replace("/",'')
				};
			} else if (hostname.includes('twitter')) {
				return {
					type:'twitter',
					href:link,
					title:pathname.replace("/",'')
				};
			} else if (hostname.includes('instagram')) {
				return {
					type:'instagram',
					href:link,
					title:pathname.replace("/",'')
				};
			}
		}
	}
	return {
		type:'website',
		href:link,
		title:link
	}
}

export function getCouponLink(integration, website, coupon, ref_code){
	if(!website || !coupon) return null;
	const w = new URL(website.includes("://") ? website : `https://${website}`)

	switch (integration){
		case "shopify": {
			w.pathname = `discount/${encodeURI(coupon)}`;
			w.searchParams.set('ref',ref_code)
			return w.href;
		}
		case "woocommerce": {
			w.searchParams.set('coupon_code', coupon)
			return w.href;
		}
	}
	return null
}
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 8)
export function randomString(){
	return nanoid()
}

export function trimPostData(postData = {}){
	const keys = Object.keys(postData);
	const toPost = {};
	for(let item of keys){
		if(postData[item] !== undefined) {
			toPost[item] = typeof postData[item] === "string" ? postData[item].trim() :  postData[item]
		}
	}
	return toPost
}
const ssnRegex = /^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/

export function isValidSSN(value: string){
	return ssnRegex.test(value)
}

export function isValidURL(url: string){
	try{
		return new URL(url)
	}catch(e){
		return false
	}
}

const formatChars = {
	'9': /[0-9]/,
	'a': /[A-Za-z]/,
	'*': /[A-Za-z0-9]/
}
export function validateValueForInputMask(inputMask, value = " "){
	return !inputMask.split("").some((char, index)=>{
		// bail out if doesn't match
		const regex = formatChars[char];
		const matches = !regex ? value[index] == char : regex.test(value[index])
		if(!matches) return true;
	})
}
export function updateImageUrl(url: string, {width, height, optimize}:{width?: number, height?: number, optimize?: boolean}){
	if(!url) return '';
	const u  = new URL(url.replace('creatives.goaffpro.com','media.goaffpro.com'))
	if(optimize) {
		// u.searchParams.append('auto_optimize', 'medium')
	}
	u.searchParams.append('optimizer', 'image')
	if(width) {
		u.searchParams.append('width', String(width))
	}
	if(height) {
		u.searchParams.append('height', String(height))
	}
	return u.href;
}
export function areThirdPartyCookiesEnabled(){
	try{
		return !!sessionStorage
	}catch(e){

	}
	return false;
}
// WARNING: This is not a drop in replacement solution and
// it might not work for some edge cases. Test your code!
const chunk = (arr: Array<any>, chunkSize = 1, cache: Array<any> = []) => {
	const tmp = [...arr]
	if (chunkSize <= 0) return cache
	while (tmp.length) cache.push(tmp.splice(0, chunkSize))
	return cache
}

export function corsUri(url: string){
	if(url){
		const u = new URL('https://cors.goaffpro.workers.dev/')
		u.searchParams.set('url',url)
		return u.href;
	}
	return url
}

export function stringToSnakeCase(str: string) {
	return str ? String(str)
		.replace(/([a-z])([A-Z])/g, '$1-$2') // Insert hyphen between lowercase and uppercase letters
		.replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
		.toLowerCase() : str; // Convert to lowercase
}


const levelColorArray = [
	"#1abc9c",
	"#2ecc71",
	"#3498db",
	"#9b59b6",
	"#34495e",
	"#16a085",
	"#27ae60",
	"#2980b9",
	"#8e44ad",
	"#2c3e50",
];

export function getColorForLevel(level: number){
	return levelColorArray[level % levelColorArray.length];
}
